import { useContext, useEffect, useState } from 'react';
import useHttp from '../../../hooks/use-http';
import { urls } from './api/urls';
import Inputs from './components/Inputs';
import toast from 'react-hot-toast';
import { handleErrorMessage } from '../../../../shared/api/handleErrorMessage';
import { TabContext } from '../../../Context/TabContext';
import TabsProvider from './components/TabsProvider';
import { convertBase64ToFile } from '../../../../utils/convertBase64ToFile';

const INITIAL_VALUES = {
  id: 0,
  nazivFirme: '',
  adresa: '',
  kontaktTelefon: '',
  email: '',
  files: [],
  ino: false,
  idRabatneGrupe: 0,
  nazivRabatneGrupe: '',
  idKlijenta: null,
  nazivKlijenta: '',
};

const Klijent = ({ save, handleSave, novi, handleNovi }) => {
  const { tabsData, activeComponent, onTabChange } = useContext(TabContext);
  const dataLocal = tabsData.find((item) => item.type === activeComponent);
  const localData = dataLocal?.data ? dataLocal?.data : INITIAL_VALUES;
  const { getData } = useHttp('');
  const localFormData = dataLocal?.formData ? dataLocal?.formData : {};
  const [formData, setFormData] = useState(localData);
  const [b64Slika, setB64Slika] = useState('');
  const [slika, setSlika] = useState('');
  const { sendRequest: vratiRabatneGrupe, data: rabatnaGrupaData } =
    useHttp('');

  useEffect(() => {
    const tab = {
      type: 10013,
      title: 'Klijent',
      icon: 'fas fa-clipboard',
      formData: formData,
    };
    onTabChange(tab);
  }, [formData]);
  useEffect(() => {
    if (Object.keys(localFormData).length > 0) {
      setFormData({
        ...localFormData,
      });
    }
  }, []);

  const vratiSlikuB64 = async () => {
    if (formData.id !== 0) {
      const config = {
        method: 'POST',
        url: 'Kupci/konvertovanje_base64_sa_id_kupca',
        data: { id: formData.id },
      };
      const response = await getData(config);
      if (response) {
        if (!response.includes('Nema')) {
          setB64Slika(response);
        }
      }
    }
  };
  useEffect(() => {
    const configTipMasine = {
      url: urls.GET_RANATNE_GRUPE,
    };
    vratiRabatneGrupe(configTipMasine);
  }, []);

  useEffect(() => {
    if (localData.id > 0) {
      vratiSlikuB64();
    }
  }, [formData]);
  useEffect(() => {
    if (formData.name !== null && formData.type !== null && b64Slika !== '') {
      const resultSlika = convertBase64ToFile(
        b64Slika,
        formData.name,
        formData.type,
      );
      console.log('result slika', resultSlika);
      setFormData((curr) => {
        return { ...curr, files: [resultSlika] };
      });
    }
  }, [formData.name, formData.type, b64Slika]);
  useEffect(() => {
    if (novi) {
      setFormData(INITIAL_VALUES);
      setB64Slika('');
      setSlika('');
      handleNovi(false);
    }
  }, [novi]);

  const handleSaveData = async () => {
    const fd = new FormData();

    fd.append('id', formData.id);
    fd.append('nazivFirme', formData.nazivFirme);
    fd.append('adresa', formData.adresa);
    fd.append('kontaktTelefon', formData.kontaktTelefon);
    fd.append('email', formData.email);
    fd.append('idKorProm', +localStorage.idKorisnika);
    fd.append('ino', formData.ino);
    if (formData.idRabatneGrupe) {
      fd.append('idRabatneGrupe', formData.idRabatneGrupe);
    }

    for (let i = 0; i < formData.files?.length; i += 1) {
      fd.append('Slika', formData.files[0]);
    }
    const config = {
      method: 'POST',
      url: formData.id === 0 ? urls.INSERT_KUPAC : urls.UPDATE_KUPAC,
      data: fd,
    };
    const result = await getData(config);
    if (result.id > 0) {
      setFormData(result);
      // vratiGrid();
      toast.success(
        formData.id === 0 ? 'Uspešan unos klijenta' : 'Uspešna izmena klijenta',
      );
      return;
    }
    toast.error(handleErrorMessage(result));
  };
  useEffect(() => {
    if (save) {
      handleSaveData();
      handleSave(false);
    }
  }, [save]);

  return (
    <div>
      <Inputs
        formData={formData}
        setFormData={setFormData}
        b64Slika={b64Slika}
        setB64Slika={setB64Slika}
        slika={slika}
        setSlika={setSlika}
        rabatnaGrupaData={rabatnaGrupaData}
      />
      <TabsProvider idKlijenta={formData.id} />
    </div>
  );
};

export default Klijent;
